<template>
  <div id="relic-list">
    <table-header-search-vue
      :deleteList="deleteRelicList"
      @onShowDelete="handleShowDelete"
      @onShowAdd="handleOpenCreateRelic"
      @onSearchTableItem="handleSearchRelic"
    />
    <table-vue
      :columns="relicListTable"
      :controllers="controllers"
      :tableData="relicList"
      @onSelectItem="handleSelectRelic"
      @onControllerChange="handleRelicControllerChange"
      @onTableItemToDetail="handleRowClick"
      @onChangeSort="handleChangeSort"
    />
    <table-footer-pagination-vue
      @onChangePage="handleChangePage"
      @onChangePageSize="handleChangePageSize"
      :totalNum="totalNum"
    />
    <!-- 创建建筑弹窗 -->
    <relic-create-vue
      v-model="showRelicCreate"
      @onConfirmCreateRelic="handleConfirmCreate"
      @onCancelCreateRelic="handleCancelCreate"
    />

    <!-- 删除建筑弹窗 -->
    <confirm-delete-popup-vue
      v-model="showDelete"
      v-if="showDelete"
      @onConfirmDelete="handleConfirmDelete"
      @onCancelDelete="handleCancelDelete"
    />
    <file-uploader-ctrl-vue v-if="false" />
  </div>
</template>

<script>
import tableVue from '../../components/layout/table.vue';
import { relicListTable } from '../../components/relic/relic-list-table.js';
import tableFooterPaginationVue from '../../components/layout/table-footer-pagination.vue';
import tableHeaderSearchVue from '../../components/layout/table-header-search.vue';
import relicCreateVue from '../../components/relic/relic-create.vue';
import {
  RELIC_TYPE,
  PROTECT_LEVEL,
  AREA,
  STATUS,
  AREA_MAP,
  STATUS_MAP,
  LEVEL_MAP,
  TYPE_MAP
} from '../../config/constant';
import { searchRelic, deleteRelic, getUserList } from '../../api/index';
import confirmDeletePopupVue from '../../components/layout/confirm-delete-popup.vue';
import { mapGetters } from 'vuex';
import { roleJudge } from '../../config/roleJudge.js';
import fileUploaderCtrlVue from '../../components/layout/file-uploader-ctrl.vue';
import { sliceParamAarry } from '../../config/utils';

export default {
  name: 'Relic',

  components: {
    tableVue,
    tableFooterPaginationVue,
    tableHeaderSearchVue,
    relicCreateVue,
    confirmDeletePopupVue,
    fileUploaderCtrlVue
  },
  computed: {
    ...mapGetters('login', ['authorizationLimit'])
  },
  data() {
    return {
      relicListTable,
      relicList: [], // 建筑列表
      showRelicCreate: false, //控制显示创建建筑弹窗
      deleteRelicList: [], //储存删除建筑列表
      totalNum: 0, //记录总条数
      page: 1,
      pageSize: 20,
      showDelete: false, //控制删除弹窗
      typeValue: '',
      levelValue: '',
      areaValue: '',
      statusValue: '',
      controllers: {
        relicTypeEnum: {
          list: RELIC_TYPE,
          value: ''
        },
        protectionLevelEnum: {
          list: PROTECT_LEVEL,
          value: ''
        },
        relicDistrictEnum: {
          list: AREA,
          value: ''
        },
        inspectStatusEnum: {
          list: STATUS,
          value: ''
        }
      } // 表头控制器
    };
  },

  mounted() {
    this.initRelicList();
  },

  methods: {
    /**
     * 取消删除
     */
    handleCancelDelete() {
      this.showDelete = false;
    },
    /**
     * * 初始化建筑列表
     */
    initRelicList({
      frameContent,
      inspectStatusEnum = this.statusValue,
      page,
      pageSize,
      protectionLevelEnum = this.levelValue,
      relicDistrictEnum = this.areaValue,
      relicFromUserIdAsc,
      relicTypeEnum = this.typeValue
    } = {}) {
      searchRelic({
        frameContent,
        inspectStatusEnum,
        page,
        pageSize,
        protectionLevelEnum,
        relicDistrictEnum,
        relicFromUserIdAsc,
        relicTypeEnum
      }).then(res => {
        if (res.data.code == 200) {
          const { items } = res.data.data;
          const { totalNum } = res.data.data;

          items.forEach(item => {
            item.relicTypeEnum = TYPE_MAP.get(item.relicTypeEnum);
            item.relicDistrictEnum = AREA_MAP.get(item.relicDistrictEnum);
            item.protectionLevelEnum = LEVEL_MAP.get(item.protectionLevelEnum);
            item.inspectStatusEnum = STATUS_MAP.get(item.inspectStatusEnum);
          });
          this.relicList = items;
          this.totalNum = totalNum;
        }
      });
    },
    handleChangeSort(sortType, sortParam) {
      this.initRelicList({ relicFromUserIdAsc: sortType });
    },
    /**
     * 监听改变页码回调
     */
    handleChangePage(page) {
      this.page = page;
      this.initRelicList({ page, pageSize: this.pageSize });
    },

    /**
     * 监听页面条数回调
     */
    handleChangePageSize(pageSize) {
      this.pageSize = pageSize;
      this.initRelicList({ page: this.page, pageSize });
    },

    /**
     * 监听删除弹窗显示回调
     */
    handleShowDelete(showDelete) {
      if (this.deleteRelicList[0]) {
        this.showDelete = showDelete;
      }
    },

    /**
     * 确定删除回调
     */
    handleConfirmDelete() {
      deleteRelic(this.deleteRelicList).then(res => {
        this.$prompt('删除成功');
        this.showDelete = false;
        // this.$refs.pagination;
        const pageNum = Math.ceil(this.totalNum / this.pageSize);
        const deletedPageNum = Math.ceil(
          (this.totalNum - this.deleteRelicList.length) / this.pageSize
        );
        this.page =
          this.page === pageNum && pageNum > deletedPageNum && this.page != 1
            ? this.page - 1
            : this.page;
        this.initRelicList({ page: this.page, pageSize: this.pageSize });
      });
    },

    /**
     * 监听确定创建建筑回调
     */
    handleConfirmCreate() {
      this.$prompt('创建成功');
      this.initRelicList();
    },

    /**
     * 监听取消回调
     */
    handleCancelCreate() {
      this.showRelicCreate = false;
      this.$prompt('取消创建');
    },

    /**
     * 监听表格选中事件
     */
    handleSelectRelic(itemList) {
      this.deleteRelicList = itemList;
    },

    /**
     * 监听选择器回调
     */
    handleRelicControllerChange(controller) {
      if (controller.list[1].value == 'GUYIZHI') {
        this.typeValue = controller.value;
      } else if (controller.list[1].value == 'GUOBAO') {
        this.levelValue = controller.value;
      } else if (controller.list[1].value == 'CHENGXIANGJIEDAO') {
        this.areaValue = controller.value;
      } else if (controller.list[1].value == 'NORMAL') {
        this.statusValue = controller.value;
      }
      this.initRelicList({
        inspectStatusEnum: this.statusValue,
        protectionLevelEnum: this.levelValue,
        relicDistrictEnum: this.areaValue,
        relicTypeEnum: this.typeValue
      });
    },

    /**
     * 监听显示创建建筑回调
     */
    handleOpenCreateRelic(showAdd) {
      this.showRelicCreate = showAdd;
    },

    /**
     * 监听搜索框回调
     */
    handleSearchRelic(searchKeyWords) {
      this.initRelicList({
        frameContent: searchKeyWords,
        inspectStatusEnum: this.statusValue,
        protectionLevelEnum: this.levelValue,
        relicDistrictEnum: this.areaValue,
        relicTypeEnum: this.typeValue
      });
    },

    /**
     * * 建筑点击回调
     */
    handleRowClick(row) {
      this.$router.push({ path: `relic/${row.relicAutoIncrementId}` });
    }

    // /**
    //  * 点击建筑状态栏进入单个建筑的巡查报告
    //  */
    // handleToReportByRelic(row) {
    //   const { relicAutoIncrementId, relicName, relicFromUserId } = row;
    //   this.$router.push({
    //     name: 'ReportDetail',
    //     params: {
    //       id: relicAutoIncrementId,
    //       name: relicName,
    //       fromUserID: relicFromUserId
    //     }
    //   });
    // }
  }
};
</script>

<style></style>
